module.exports = __webpack_public_path__ + "img/anne_marie.0fbe95e7.jpg";